// Dependencies imports
import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbar,
} from "@material-ui/data-grid";
import { API } from "aws-amplify";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Skeleton from "@material-ui/lab/Skeleton";
import Link from "@material-ui/core/Link";

// Local imports
import CreateUser from "./CreateUser";
import UserBulkUpload from "./UserBulkUpload";
import EditUser from "./EditUser";
import config from "../../config/aws-exports";
import { awsSignIn, authData } from "../../redux/auth/authSlice";
import UserHeader from "../Header/UserHeader/UserHeader";
import { Constants } from "../../config/constants";
import DeletePlatUser from "./DeletePlatUser";
import { ReactComponent as Delete } from "../../assets/svg/delete_black_24dp.svg";
import { ReactComponent as Edit } from "../../assets/svg/edit_black_24dp.svg";

// Styles imports
import Use from "./User.module.scss";

// const rows = [
//   { id: 1, col1: 'Hello', col2: 'World' },
//   { id: 2, col1: 'XGrid', col2: 'is Awesome' },
//   { id: 3, col1: 'Material-UI', col2: 'is Amazing' },
// ];

// const columns1 = [
//   { field: 'col1', headerName: 'Name', width: 150 },
//   { field: 'col2', headerName: 'Email', width: 150 },
//   { field: 'col3', headerName: 'Role', width: 150 },
//   { field: 'col4', headerName: 'Last Active', width: 150 },
//   { field: 'col5', headerName: 'Status', width: 150 },

// ];

// let columns = [];
function CustomToolbar() {
  return (
    <GridToolbarContainer
      style={{ display: "flex", justifyContent: "flex-end" }}
    >
      <GridToolbar />
    </GridToolbarContainer>
  );
}

const useStyles = makeStyles({
  root: {
    "& .super-app-theme--header": {
      backgroundColor: config.main_color_1,
      fontSize: "16px",
      color: "rgb(255,255,255)",
      fontFamily: "nunito",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
  },
  ".MuiDataGrid-root": {
    fontSize: "14px",
    fontFamily: "nunito",
    fontWeight: 400,
    color: "black",
    cursor: "pointer",
  },
});

function Users() {
  const [usersJSON, setUsersJSON] = useState([]);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(true);
  const classes = useStyles();
  const [openDelete, setOpenDelete] = useState(false);
  // let userDetails = useSelector(authData);
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openBulk, setOpenBulk] = useState(false);
  // const [mod, setmod] = useState(false);
  const [editUserData, setEditUserData] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpenEdit = () => {
    setOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const handleCellClick = (param, event) => {
    console.log(param.row);
    if (param.field == "edit") {
      setOpenEdit(true);
      setEditUserData(param.row);
    } else {
      handleDeleteOpen(true);
      setEditUserData(param.row);
    }

    // console.log(event);
  };

  useEffect(() => {
    getUsersDetails();
  }, []);

  const handleDeleteOpen = () => {
    setOpenDelete(true);
  };
  async function downloadcsv() {
    const response = await fetch("userlist.csv");
    const data = await response.text();
    const blob = new Blob([data], { type: "data:text/csv;charset=utf-8," });
    const url = window.URL.createObjectURL(blob);
    let dwldLink = document.createElement("a");
    let isSafariBrowser =
      navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1;
    if (isSafariBrowser) {
      //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", "userlist.csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  const handleDeleteClose = () => {
    setOpenDelete(false);
  };
  const handleBulkOpen = () => {
    setOpenBulk(true);
  };

  const handleBulkClose = () => {
    setOpenBulk(false);
  };
  async function getUsersDetails() {
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_USERS,
        bodyParam
        //`${Constants.GET_MY_PROGRAMS}`, bodyParam,
      );
      const users = response;
      console.log("uresponse" + JSON.stringify(users));
      let trows = [];
      for (let i = 0; i < users.length; i++) {
        let obj = {};
        obj.id = i;
        obj.col1 = users[i].UNAME;
        obj.col2 = users[i].EMAILID;
        obj.col3 = users[i].UR;
        // obj.col4 = users[i].LA;
        if (users[i].LA === undefined) {
        } else {
          var diff = moment.utc(users[i].LA).fromNow();
          // users[i].LA = diff;
          obj.col4 = diff;
          console.log("Last Active" + JSON.stringify(diff));
        }
        if (users[i].US === 1 || users[i].US === "1") {
          obj.col5 = "Active";
        } else {
          obj.col5 = "Not Active";
        }
        // obj.col5 = users[i].US;
        obj.col6 = users[i].GEN;
        obj.col7 = users[i].CNO;
        obj.col8 = users[i].ADS;
        obj.col9 = users[i].EID;
        trows.push(obj);
      }

      const tcolumns = [
        {
          field: "col1",
          headerName: "Name",
          flex: 1,
          headerClassName: "super-app-theme--header",
        },
        {
          field: "col2",
          headerName: "Email",
          flex: 1,
          headerClassName: "super-app-theme--header",
        },
        {
          field: "col3",
          headerName: "Role",
          flex: 1,
          headerClassName: "super-app-theme--header",
        },
        {
          field: "col4",
          headerName: "Last Active",
          flex: 1,
          headerClassName: "super-app-theme--header",
        },
        {
          field: "col5",
          headerName: "Status",
          flex: 1,
          headerClassName: "super-app-theme--header",
        },
        {
          field: "col6",
          headerName: "Gender",
          flex: 1,
          headerClassName: "super-app-theme--header",
        },
        {
          field: "edit",
          headerName: "Edit User",
          flex: 1,
          sortable: false,
          disableExport: true,
          disableClickEventBubbling: true,
          headerClassName: "super-app-theme--header",
          renderCell: (param) => {
            return (
              <Button
                size="small"
                // style={{ color: "white", background: config.main_color_1, fontSize: "12px", fontWeight: "bold" }}
                startIcon={<Edit />}
                onClick={(event) => {
                  handleCellClick(param, event);
                }}
              ></Button>
            );
          },
        },
        {
          field: "delete",
          headerName: "Delete User",
          flex: 1,
          sortable: false,
          disableExport: true,
          disableClickEventBubbling: true,
          headerClassName: "super-app-theme--header",
          renderCell: (param) => {
            return (
              <Button
                size="small"
                // style={{ color: "white", background: "#f32013", fontSize: "12px", fontWeight: "bold" }}
                startIcon={<Delete />}
                onClick={(event) => {
                  handleCellClick(param, event);
                }}
              ></Button>
            );
          },
        },
        // { field: 'col7', headerName: 'CNO', flex:1, headerClassName: 'super-app-theme--header' },
        // { field: 'col8', headerName: 'Addres', flex:1,headerClassName: 'super-app-theme--header' },
      ];
      setRows(trows);
      setColumns(tcolumns);
      setLoading(false);
      // setIsLoading(false);
    } catch (error) {
      alert(error);
      console.log("getUserError", error);
    }
    console.log("Mount");
  }
  return (
    <div className={Use.maincontainer}>
      <UserHeader />
      <div className={Use.holder}>
        <h3 className={Use.header}>Manage Users</h3>
        <div style={{ display: "flex", alignItems: "center", gap: "2rem" }}>
          <a
            style={{ fontSize: "13px", cursor: "pointer", color: "blue" }}
            onClick={downloadcsv}
          >
            Download Format
          </a>
          <button
            onClick={handleBulkOpen}
            className={
              window.navigator.onLine === true
                ? Use.btn_color
                : Use.btn_colordis
            }
            disabled={!window.navigator.onLine}
          >
            Bulk Upload
          </button>
          <button
            onClick={handleClickOpen}
            className={
              window.navigator.onLine === true
                ? Use.btn_color
                : Use.btn_colordis
            }
            disabled={!window.navigator.onLine}
          >
            Create User
          </button>
        </div>
      </div>

      {/* <Button variant="outlined" color="primary" onClick={handleClickOpenEdit}>
        Edit User
      </Button> */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openBulk}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openBulk}>
          <UserBulkUpload handleClose={handleBulkClose} type="user" />
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <CreateUser
            handleClose={handleClose}
            getUsersDetails={getUsersDetails}
            rows={rows}
          />
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openDelete}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openDelete}>
          <DeletePlatUser
            handleDeleteClose={handleDeleteClose}
            getUsersDetails={getUsersDetails}
            editUserData={editUserData}
          />
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openEdit}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <EditUser
            handleClose={handleCloseEdit}
            editUserData={editUserData}
            getUsersDetails={getUsersDetails}
          />
        </Fade>
      </Modal>
      <div style={{ height: 600, width: "100%" }} className={classes.root}>
        {loading === false ? (
          <DataGrid
            rows={rows}
            columns={columns}
            className={classes[".MuiDataGrid-root"]}
            components={{
              Toolbar: CustomToolbar,
            }}
            disableSelectionOnClick
          />
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Skeleton variant="rect" width="100%" height={600} />{" "}
          </div>
        )}
      </div>
    </div>
    // CustomToolbar for only export    // for all
    // <div style={{ height: 300, width: '100%' }}>
    //   <div style={{ display: 'flex', height: '100%' }}>
    //     <div style={{ flexGrow: 1 }}>
    //     <DataGrid rows={rows} columns={columns} />
    //     </div>
    //   </div>
    // </div>
  );
}
export default Users;
